import Vue from 'vue';
const LKFilter = {
  initFilter: function() {
    Vue.filter('star', this.star);
    Vue.filter('abstract', this.abstract);
    Vue.filter('removeHtmlTag', this.removeHTMLTag);
    Vue.filter('toYuan', this.toYuan);
    Vue.filter('imgUrl', this.imageUrl);
  },
  //内容加*处理  content 内容 length 预留内容长度 type 加*位置 "front" "mid" "back"
  star: function(content, length, type) {
    if (typeof content == 'string' && content.constructor == String) {
      let star = '****';
      if (content.length <= length || length <= 0) {
        return star;
      }

      if (type == 'front') {
        let str = content.substring(0, length);
        return str + star;
      } else if (type == 'mid') {
        let start = Math.floor((content.length - length) / 2.0);
        let str = content.substring(start, start + length);
        return star + str + star;
      } else if (type == 'back') {
        let start = content.length - length;
        let str = content.substring(start, start + length);
        return star + str;
      } else {
        let str = content.substring(0, length);
        return str + star;
      }
    }
    return '';
  },
  starEx: function(content, frontLength, endLength, starLength) {
    //前边留的位数
    if (frontLength <= 0) {
      frontLength = 1;
    }
    //末位留的位数
    if (endLength <= 0) {
      endLength = 1;
    }
    //加* 的数量
    if (starLength <= 0) {
      starLength = 3;
    }

    if (content == null || typeof content != 'string') {
      return '';
    }

    if (content.length < frontLength + endLength) {
      return content;
    }
    let strStar = '';
    for (let i = 0; i < starLength; i++) {
      strStar += '*';
    }

    let result =
      content.substr(0, frontLength) +
      strStar +
      content.substr(content.length - endLength, endLength);

    return result;
  },
  //获取摘要  content 内容  maxLength 摘要最大长度
  abstract: function(content, maxLength) {
    // let content = this.activityInfo.content;
    if (typeof content == 'undefined' || content.length == 0) {
      return '';
    }
    let length = maxLength;
    if (content.length < maxLength) {
      // length = content.length;
      return content;
    }
    return content.substring(0, length) + '...';
  },
  removeHTMLTag: function(content) {
    if (typeof content == 'undefined' || content == null) {
      return '';
    }
    if (typeof content !== 'string') {
      return '';
    }
    content = content.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
    content = content.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
    content = content.replace(/\n[\s| | ]*\r/g, '\n'); //去除多余空行
    content = content.replace(/&nbsp;/gi, ''); //去掉&nbsp;
    return content;
  },
  toYuan: function(fen, length) {
    let num = new Number(fen / 100.0);
    return num.toFixed(length < 0 ? 0 : length);
  },
  imageUrl: function(url, width, height) {
    if (width == 0 && height == 0) {
      return url;
    }
    width = Math.floor(width);
    height = Math.floor(height);
    let tmp = url + '?imageView2/1/w/' + width + '/h/' + height;
    return tmp;
  },
};

export default LKFilter;
